import { merchantApi } from '@/config/axios'

export interface O2oMerchantDashboardSummaryVO {
  todayGmv?: number
  todayOrderCount?: number
  monthGmv?: number
  monthOrderCount?: number
  totalOrderCount?: number
  processingOrderCount?: number
  pendingAssignCount?: number
  monthCompletedCount?: number
  activeProviderCount?: number
  avgReviewScore?: number
}

export interface O2oMerchantDashboardTrendVO {
  dates?: string[]
  gmv?: number[]
  orderCount?: number[]
}

export interface O2oMerchantDashboardProviderRankVO {
  providerId?: number
  providerName?: string
  completedCount?: number
  completedGmv?: number
  avgReviewScore?: number
}

export function getO2oMerchantDashboardSummary() {
  return merchantApi.get<O2oMerchantDashboardSummaryVO>({ url: '/merchant-api/o2o/dashboard/summary' })
}

export function getO2oMerchantDashboardTrend() {
  return merchantApi.get<O2oMerchantDashboardTrendVO>({ url: '/merchant-api/o2o/dashboard/trend' })
}

export function getO2oMerchantDashboardProviderRank(limit = 10) {
  return merchantApi.get<O2oMerchantDashboardProviderRankVO[]>({
    url: '/merchant-api/o2o/dashboard/provider-rank',
    params: { limit }
  })
}

export function getO2oMerchantAvailabilityStats() {
  return merchantApi.get<{
    capacity: number
    booked: number
    idleRate: number
    unavailableSlotCount: number
    slaTimeoutCount: number
  }>({ url: '/merchant-api/o2o/dashboard/availability-stats' })
}
